import React from 'react';
import { RefreshCw, XCircle } from 'lucide-react';

// Extracted from WorkerDashboard.js — receives everything it needs via `ctx`.
export default function WorkerRejectModal({ ctx }) {
  const { actionLoading, handleRejectShift, rejectReason, setRejectReason, setShowRejectModal, showRejectModal } = ctx;
  return (
    <>
    {showRejectModal && (
      <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl w-full max-w-md">
          <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-red-500 to-pink-600 rounded-t-2xl">
            <div className="flex items-center gap-3 text-white">
              <XCircle className="w-7 h-7" />
              <div>
                <h3 className="text-lg font-bold">Reject Shift</h3>
                <p className="text-sm text-white/80">{showRejectModal.title}</p>
              </div>
            </div>
          </div>
          <div className="p-6">
            <p className="text-gray-600 mb-4">Are you sure you want to reject this shift? This action cannot be undone.</p>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">Reason (optional)</label>
              <textarea
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Let the employer know why you're rejecting..."
                className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-800 resize-none"
                rows={3}
                data-testid="reject-reason-input"
              />
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowRejectModal(null);
                  setRejectReason('');
                }}
                className="flex-1 px-4 py-3 text-gray-600 hover:bg-gray-100 rounded-xl transition"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectShift}
                disabled={actionLoading}
                className="flex-1 px-4 py-3 bg-red-600 text-white rounded-xl font-medium hover:bg-red-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
                data-testid="confirm-reject-shift-btn"
              >
                {actionLoading && <RefreshCw className="w-4 h-4 animate-spin" />}
                Reject Shift
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
